export default __webpack_public_path__ + "static/media/weebly.8b6a3366.svg";